export class MotivoAnulacionCompra {
            public codMotivoCompra: number;
            public codMotivoCompraErp: string;
            public codEmpresa: number;
            public descripcion: string;
            constructor() { }
    }
